import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { FeaturedStyleWrapper } from "./styles";
import classNames from "classnames";
import IconButton from "../../IconButton";
import { Button } from "../../Button";

Modal.setAppElement("#root");

const FeaturedStylesSelector = ({ isOpen, setIsOpen, onStyleSelect, writingStyles }) => {
  const [selectedStyle, setSelectedStyle] = useState(null);

  useEffect(() => {
    setSelectedStyle(writingStyles[0]);
  }, []);

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={setIsOpen}
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(55, 55, 55, 0.7)",
          zIndex: "100000001",
        },
        content: {
          top: "5%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          zIndex: "20000",
          width: "760px",
          transform: "translate(-50%, 0)",
          borderRadius: "15px",
          border: "0px",
          padding: "0px",
          background: "none",
          boxShadow: "var(--default-drop-shadow)",
          height: "522px",
          maxHeight: "90%",
          overflowX: "hidden",
        },
      }}
    >
      {selectedStyle && (
        <FeaturedStyleWrapper>
          <div className="templates">
            <h2
              role="heading"
              aria-label="Type Header"
              tabIndex={0}
            >
              Featured Styles
            </h2>
            <hr />
            <ul>
              {writingStyles.map((t) => {
                return (
                  <li
                    tabIndex={0}
                    key={t.value}
                    className={classNames({ active: selectedStyle.value === t.value })}
                    onClick={(e) => {
                      setSelectedStyle(t);
                    }}
                    aria-label={`${t.value} type, press Enter to select.`}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        setSelectedStyle(t);
                      }
                    }}
                  >
                    {t.label}
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="template">
            <div className="description">
              <header>
                <h3
                  tabIndex={0}
                  aria-label="Heading - Outline Description"
                >
                  {selectedStyle.description}
                </h3>
                <IconButton
                  src="/assets/close.svg"
                  onClick={handleClose}
                  className="close-btn"
                  ariaLabel={`Close modal`}
                />
              </header>

              <div className="example">
                <p tabIndex={0}>{selectedStyle.sample}</p>
              </div>
            </div>

            <div className="cta">
              <Button
                tabIndex="0"
                primary
                className="use-component-styles"
                onClick={() => {
                  onStyleSelect(selectedStyle);
                  setIsOpen(false);
                }}
              >
                Use {selectedStyle.label}
              </Button>
            </div>
          </div>
        </FeaturedStyleWrapper>
      )}
    </Modal>
  );
};

export default FeaturedStylesSelector;
